import React, { useEffect, useContext, useState, useRef } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { LabelText } from '../../Language';
import HeaderTitle from '../../../hoc/HeaderTitle';
import { LanguageContext } from '../../../containers/Language/LanguageProvider';
import { getHelpVideoUrlApi } from '../../../services/business-partner-api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlayCircle } from '@fortawesome/free-solid-svg-icons';


export default function Elearning(props) {
  const { language } = useContext(LanguageContext);
  const [helpVideoUrl, sethelpVideoUrl] = useState(null);
  const [videostyle, setvideoStyle] = useState("image-mini");
  const [iconstyle, seticonStyle] = useState("playicon");
  const [isLoading, setIsLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const vidRef = useRef(null);



  useEffect(() => {
    props.setSelectedNavItem(window.location.pathname.replace(/[/]/g, ''));
    fetchVideo();
  }, []);


  useEffect(() => {
    // Clean up URL object to free memory when component unmounts
    return () => {
      if (helpVideoUrl) {
        URL.revokeObjectURL(helpVideoUrl);
      }
    };
  }, [helpVideoUrl]);

  useEffect(() => {
    if (props.isLogout) {
      props.clearSessionData();
      props.setLogoutFalse();
    }
  }, [props.isLogout]);

  const changeStyle = () => {
    setvideoStyle("image-max")
    seticonStyle("playiconhide")
    vidRef.current.play();
  }


  const fetchVideo = async () => {

    setIsLoading(true);
    setProgress(0);
    try {

      const response = await getHelpVideoUrlApi(props.BusinessPartnerCode, language.id, {
        onDownloadProgress: progressEvent => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setProgress(percentCompleted); // Update progress state
        }
      });
      const blob = new Blob([response.data], { type: 'video/mp4' });
      const url = URL.createObjectURL(blob);
      sethelpVideoUrl(url);

    } catch (error) {
      console.error('Error fetching video:', error);
    }
    finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <div className="sidebar-bottomcontent-container-row-elearning">
        <div className="sidebar-bottomcontent-container-col-elearning">
          <></>
        </div>
        <div>
          <Container className="elearning-container">
            <Row >
              <HeaderTitle className="elearning-title-container col">
                <span className="elearning-title-align">
                  <LabelText tid="help" /> - <LabelText tid="elearning" />
                </span>
                <span style={{ "float": "right", "color": "#fff", "fontSize": "1.8vw" }}>
                  {props.BusinessPartnerCode}
                </span>
              </HeaderTitle>
            </Row>
            <Row >
              <div className="e-learning-text-container row "><br />
                <span className="e-learning-content2 row " >
                  <div className="text-show">
                    <LabelText tid="elearning_useoftool" /><br />
                  </div>
                  {isLoading ? (
                    <p className="text-show"><LabelText tid="processing" />...  {progress}%</p>
                  ) :
                    (<video ref={vidRef} className={videostyle} src={helpVideoUrl}
                      controls
                      controlsList="nodownload"
                      preload="auto"
                      onPlay={changeStyle}>
                      <source src={helpVideoUrl}
                        type="video/mp4" />
                    </video>)
                  }
                  <FontAwesomeIcon className={iconstyle} icon={faPlayCircle} onClick={changeStyle} />
                </span>
              </div>
            </Row>
            <Row>
              <div className="elearning-footer"></div>
            </Row>
          </Container>
        </div>
      </div>
    </div>

  );
}